function initCustomOrderStatusCountdowns(root) {
  (root || document).querySelectorAll('.custom-order-status__countdown').forEach(function (countdown) {
    if (countdown.dataset.countdownInit === 'true') return;
    countdown.dataset.countdownInit = 'true';

    var target = new Date(countdown.dataset.countdownTarget.replace(' ', 'T'));
    if (isNaN(target.getTime())) {
      countdown.remove();
      return;
    }

    var daysEl = countdown.querySelector('[data-countdown-days]');
    var hoursEl = countdown.querySelector('[data-countdown-hours]');
    var minutesEl = countdown.querySelector('[data-countdown-minutes]');
    var secondsEl = countdown.querySelector('[data-countdown-seconds]');
    var intervalId;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function update() {
      var diff = target.getTime() - Date.now();
      if (diff < 0) diff = 0;

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      if (diff <= 0) {
        clearInterval(intervalId);
      }
    }

    update();
    intervalId = setInterval(update, 1000);
  });
}

initCustomOrderStatusCountdowns(document);

document.addEventListener('shopify:section:load', function (event) {
  initCustomOrderStatusCountdowns(event.target);
});
